import { notification } from "antd";

export const notify = (type: string, message: string, description?: string) =>
	//@ts-ignore
	notification[type]({
		message,
		description,
	});
